import { useQuery } from '@tanstack/react-query';
import { dbClient, normalizeRpcResponse } from '@/services/db-client';

export interface Ga4DayPoint {
    day: string;
    active_users: number;
    page_views: number;
}

export interface Ga4TopEvent {
    event_name: string;
    active_users: number;
    event_count: number;
}

export interface Ga4PageRow {
    path: string;
    active_users: number;
    screen_page_views: number;
}

export interface Ga4WebAudit {
    days: number;
    data_through: string | null;
    finished_at: string | null;
    pages_truncated: boolean;
    series: Ga4DayPoint[];
    top_events: Ga4TopEvent[];
    pages: Ga4PageRow[];
}

export function useGa4WebAudit(days = 28) {
    return useQuery<Ga4WebAudit>({
        queryKey: ['admin', 'ga4-web-audit', days],
        queryFn: async () => {
            const { data, error } = await dbClient.rpc<Ga4WebAudit>('get_ga4_web_audit', { p_days: days });
            if (error) throw new Error(error.message);
            const rows = normalizeRpcResponse(data);
            const first = rows[0];
            const parsed = first && typeof first === 'object' && 'get_ga4_web_audit' in first
                ? (first as { get_ga4_web_audit: Ga4WebAudit }).get_ga4_web_audit
                : (first as Ga4WebAudit);
            if (!parsed || !Array.isArray(parsed.series)) {
                throw new Error('Respuesta inválida de get_ga4_web_audit');
            }
            return parsed;
        },
    });
}
